import {createContext} from "react";

export const GlobalContext = createContext({
	reload: 0,
	users: [],
	managers: [],
});
